import PageMeta from '../../components/common/PageMeta'
import AuthLayout from './AuthPageLayout'
import SignInForm from '../../features/auth/SignInForm'

export default function SignIn() {
  return (
    <>
      <PageMeta
        title="Entrar | Optimus - Plataforma de IA Multi-Agente"
        description="Faça login na plataforma Optimus da MDi para acessar seus agentes de IA especializados"
      />
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  )
}
